import { queryOptions } from "@tanstack/react-query"
import { tasksKeys } from "./keys"
import { apiClient } from "~/lib/client"
import { handleResponse } from "~/utils/response"
import { GetTaskByEncounterId } from "../type"


export const getTasksByEncounterIdQuery = (id: string)=> {
    return queryOptions({
        queryKey: tasksKeys.getTasksByEncounterId(id),
        refetchInterval: 1000 * 5,
        queryFn: async () => {
            const response = await apiClient(`/admin/encounters/${id}`)

            const result = await handleResponse<GetTaskByEncounterId>(response)
            
            if (result.success) {
                return result.data
            } else {
                throw new Error(result.error || 'Failed to fetch tasks')
            }
        },
        select(data) {
            return {
                recommendedTasks: data.encounter.recommended_tasks.map((task) => ({
                    id: task.task_id,
                    prescriptionId: task.prescription?.prescription_id,
                    name: task.type === "medication_payment" ? "Refill": "Appointment Followup",
                    status: task.status,
                    cost: task.cost,
                    pharmacy: task.pharmacy_fulfillment,
                    createdAt: formatDate(task.created_at),
                    instructions: task.type === "appointment_followup" ? task.instructions : "",
                    medications: task.prescription?.medication || [],
                    is_erx_sent: task.is_erx_sent
                })),
                notes: data.encounter.notes,
                encounterId: data.encounter.encounter_id,
            }
        }
    })
}